module.exports = __webpack_public_path__ + "static/media/sproutingCrops.7856bc16.jpg";